import { Alert, AlertIcon, AlertTitle } from "@chakra-ui/react";
import React from "react";

const ErrorComponent = ({ message }) => {
  return (
    <Alert
      status={"error"}
      position={"fixed"}
      bottom={"20"}
      left={"50%"}
      transform={"translateX(-50%)"}
      w={"container.lg"}
      variant='solid'
    >
      {/* <AlertTitle>Error</AlertTitle> */}
      <AlertIcon />
      {message}
    </Alert>
  );
};

export default ErrorComponent;
